import { render } from "./ChevronRight.vue?vue&type=template&id=271b2cb6"
import script from "./ChevronRight.vue?vue&type=script&lang=js"
export * from "./ChevronRight.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexey/Projects/gambody-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__